module.exports = __webpack_public_path__ + "static/media/logo.080a5db1.png";